import { testerTrialForSignup, withTesterTier } from "./testerCampaign";

// Client-side mirror of the server's plan rules (server/lib/entitlements.ts and
// server/config/tierConfig.ts), so the UI can lock a feature without a server
// trip. The server still enforces every limit; this only avoids pointless calls.

export type PlanTier = "starter" | "plus" | "max";

/** Same mapping as the server's normalizePlanTier (legacy names included). */
export function normalizePlanTier(value: unknown): PlanTier {
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : "";
  if (normalized === "plus" || normalized === "pro" || normalized === "premium") return "plus";
  if (normalized === "max" || normalized === "elite") return "max";
  return "starter";
}

/**
 * The tier actually in force. A paid plan whose expiry has passed is Starter,
 * exactly as the server treats it; no expiry date means the plan is active.
 */
export function effectivePlanTier(
  account: { id?: string; created_at?: string; billing_plan_tier?: unknown; plan_tier?: unknown; subscription_expiry?: unknown } | null | undefined,
  now: Date = new Date(),
): PlanTier {
  const tier = normalizePlanTier(account?.billing_plan_tier ?? account?.plan_tier);
  const expiry = typeof account?.subscription_expiry === "string" ? new Date(account.subscription_expiry) : null;
  const lapsed = expiry !== null && !Number.isNaN(expiry.getTime()) && expiry <= now;
  const base = lapsed ? "starter" : tier;
  const trial = account?.id ? testerTrialForSignup(account.id, account.created_at, now.getTime()) : null;
  return withTesterTier(base, trial);
}

/** Read Aloud is Plus and Max (tierConfig audioAccess: "tts-only" and "full"). */
export function canReadAloud(tier: PlanTier): boolean {
  return tier === "plus" || tier === "max";
}

export const READ_ALOUD_LOCKED_MESSAGE = "Read aloud is part of Novari Plus and Max. Tap to see plans.";
